<template>
    <div class="login-container">
        <div class="login-header">
            <h3 class="center">Ostanite prejemnik naših <span class="bold">ekskluzivnih ugodnosti in popustov!</span><br/>
            Uredite vaše osebne podatke in privolitve.</h3>
        </div>
        <div class="login-form">
            <form method="POST" action="">
                <div class="login-label-container center">
                    <label for="code">Vnesite vašo unikatno kodo:</label>
                    <input type="text" name="code" v-model="uniqueKey" :class="{handleError: error}">
                </div>
                <div class="error-msg-container" v-if="error">
                    <p class="error-msg">Vnesli ste napačno kodo.</p>
                </div>
                <div class="submit-key-btn center">
                    <button type="submit" class="btn btn-lg btn-primary" @click.prevent="submit()">POTRDITE</button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            uniqueKey: "",
            error: false
        }
    },
    methods: {
        submit() {
            if(this.uniqueKey != "") {
                this.$store.state.uniqueKey = this.uniqueKey
                this.$http.get('/backend/api/v1/key/' + this.uniqueKey).then( (response) => {
                    if (response.body) {
                        console.log(response.body)
                        if (response.body.user) {
                            if (response.body.user.ime) {
                                this.$store.state.ime = response.body.user.ime
                            }
                            if (response.body.user.priimek) {
                                this.$store.state.priimek = response.body.user.priimek
                            }
                            if (response.body.user.email) {
                                this.$store.state.email = response.body.user.email
                            }
                            if (response.body.user.street) {
                                this.$store.state.street = response.body.user.street
                            }
                            if (response.body.user.title) {
                                this.$store.state.title = response.body.user.title
                                this.$store.state.form.user.title = response.body.user.title
                                this.$store.state.dropdowns.gender.validation = true
                            }
                            if (response.body.user.postOffice) {
                                this.$store.state.postOffice = response.body.user.postOffice
                            }
                            if (response.body.user.postNumber) {
                                this.$store.state.postNumber = response.body.user.postNumber
                            }
                            if (response.body.user.telephone) {
                                this.$store.state.telephone = response.body.user.telephone
                            }
                        }

                        if (response.body.gdpr) {
                            if (response.body.gdpr.ponudbaNakup === true || response.body.gdpr.ponudbaNakup === false) {
                                this.$store.state.form.gdpr.ponudbaNakup = response.body.gdpr.ponudbaNakup
                                this.$store.state.buttons.ponudbaNakupBtn.value = response.body.gdpr.ponudbaNakup
                                this.$store.state.buttons.ponudbaNakupBtn.error = false
                            }
                            if (response.body.gdpr.ponudbaPoprodajni === true || response.body.gdpr.ponudbaPoprodajni === false) {
                                this.$store.state.form.gdpr.ponudbaPoprodajni = response.body.gdpr.ponudbaPoprodajni
                                this.$store.state.buttons.ponudbaPoprodajniBtn.value = response.body.gdpr.ponudbaPoprodajni
                                this.$store.state.buttons.ponudbaPoprodajniBtn.error = false
                            }
                            if (response.body.gdpr.personalizacija === true || response.body.gdpr.personalizacija === false) {
                                this.$store.state.form.gdpr.personalizacija = response.body.gdpr.personalizacija
                                this.$store.state.buttons.personalizacijaBtn.value = response.body.gdpr.personalizacija
                                this.$store.state.buttons.personalizacijaBtn.error = false
                            }
                            if (response.body.gdpr.eNovice === true || response.body.gdpr.eNovice === false) {
                                this.$store.state.form.gdpr.eNovice = response.body.gdpr.eNovice
                                this.$store.state.buttons.eNoviceBtn.value = response.body.gdpr.eNovice
                                this.$store.state.buttons.eNoviceBtn.error = false
                            }

                            if (response.body.gdpr.ePosta) {
                                this.$store.state.checkboxes.ePosta.value = response.body.gdpr.ePosta
                                this.$store.state.form.gdpr.ePosta = response.body.gdpr.ePosta
                                this.checkCheckBoxes()
                            }
                            if (response.body.gdpr.sms) {
                                this.$store.state.checkboxes.sms.value = response.body.gdpr.sms
                                this.$store.state.form.gdpr.sms = response.body.gdpr.sms
                                this.checkCheckBoxes()
                            }
                            if (response.body.gdpr.telefon) {
                                this.$store.state.checkboxes.telefon.value = response.body.gdpr.telefon
                                this.$store.state.form.gdpr.telefon = response.body.gdpr.telefon
                                this.checkCheckBoxes()
                            }
                            if (response.body.gdpr.posta) {
                                this.$store.state.checkboxes.posta.value = response.body.gdpr.posta
                                this.$store.state.form.gdpr.posta = response.body.gdpr.posta
                                this.checkCheckBoxes()
                            }
                        }
                        this.$router.push({ name: 'Form' })
                        this.error = false;
                    }
                }).catch(function(data) {
                    if(data.status === 401) {
                        this.error = true;
                    }
                })
            } else {
                this.error = true;
            }
        },
        checkCheckBoxes() {
            this.$store.state.checkboxValidation = true
        }
   }
}
</script>
<style lang="scss" scoped>
  .center {
    text-align: center;
  }

  .bold {
    font-weight: bold;
  }

  .login-label-container {
      margin: 50px 0 0 0;
      label {
          display: block;
          font-size: 15px;
      }
      input {
          padding: 5px;
          border: 1px solid #999;
          box-shadow: 0px 0px 0px #fff;
          transition: box-shadow 0.5s ease-in-out;
          line-height: 20px;
          display: inline-block;
          width: auto !important;
          font-size: 14px;
      }
      input:focus {
          box-shadow: 0px 0px 5px #c3002f;
          transition: box-shadow 0.1s ease-in-out;
      }
  }

  .handleError {
    border: 1px solid red!important;
  }

  .error-msg-container {
    text-align: center;
  }

  .error-msg {
    color: red;
  }

  .submit-key-btn {
    text-align: center;
    margin: 10% 0 3% 0;
    button {
      background-color: #c3002f;
      border-color: #c3002f;
      padding: 10px 85px;
      border-radius: 25px;
      position: relative;
      font-family: Nissan Regular,Helvetica,Arial,sans-serif;
    }
    button:hover {
      background-color: #9b0025;
      border-color: #9b0025;
    }
    button:after{
      font-size: 20px;
      position: absolute;
      top: 35%;
      margin-top: -.3333333333em;
      right: 30px;
      content: ">";
    }
  }

  @media only screen and (max-width: 768px) {
    .submit-key-btn {
      margin: 40px 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue